export default class TourVirtualUmbracoResponse {
    videoIntro: string;
  }
  